/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refundPayment} from '../api'

export const useMutationRefundPayment = createReactQueryMutationHook('refundPayment', refundPayment)
